import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Notification, toast } from 'components/ui'
import {
    getBrands,
    getCategories,
    getCustomerById,
    getCustomers,
    getDeliveryPartners,
    getDressTypes,
    getFabrics,
    getMeasurementFields,
    getProducts,
    getSupplierById,
    getSuppliers,
    getUnits,
} from 'services'
import { getColors } from 'services/ColorsService'
import {
    getClientChilds,
    getClientSizes,
} from 'services/MeasurementFieldsService'
import { getFabricBySearch, getProductsBySearch } from 'services/ProductService'
import { getTailors } from 'services/TailorService'

// Simplified error message utility
const getErrorMessage = (error) => {
    error?.response?.data?.error ||
        error?.response?.data?.debugInfo ||
        error?.response?.data?.message ||
        error?.response?.data ||
        error.toString()
}
// Helper function to create async thunks with less boilerplate
const createAsyncThunkWithNotification = (type, asyncFunction) => {
    // Log the type argument
    return createAsyncThunk(type, async (arg, thunkAPI) => {
        try {
            return await asyncFunction(arg)
        } catch (error) {
            const message = getErrorMessage(error)
            return thunkAPI.rejectWithValue(message)
        }
    })
}
export const get_customers_drd = createAsyncThunkWithNotification(
    'customers/data/get_customers_drd',
    getCustomers
)

export const get_taiilor_drd = createAsyncThunkWithNotification(
    'customers/data/get_taiilor_drd',
    getTailors
)

export const get_product_drd = createAsyncThunkWithNotification(
    'customers/data/get_product_drd',
    getProducts
)

export const get_product_by_search = createAsyncThunkWithNotification(
    'customers/data/get_product_by_search',
    getProductsBySearch
)

export const get_fabric_by_search = createAsyncThunkWithNotification(
    'customers/data/get_fabric_by_search',
    getFabricBySearch
)

export const get_dress_type_drd = createAsyncThunkWithNotification(
    'customers/data/get_dress_type_drd',
    getDressTypes
)
export const get_colors_drd = createAsyncThunkWithNotification(
    'customers/data/get_colors_drd',
    getColors
)
export const get_measurement_fields_drd = createAsyncThunkWithNotification(
    'customers/data/get_measurement_fields_drd',
    getMeasurementFields
)
export const get_client_sizes = createAsyncThunkWithNotification(
    'customers/data/get_client_sizes',
    getClientSizes
)
export const get_client_childs = createAsyncThunkWithNotification(
    'customers/data/get_client_childs',
    getClientChilds
)
export const get_client_by_id = createAsyncThunkWithNotification(
    'customers/data/get_client_by_id',
    getCustomerById
)

export const get_units_drd = createAsyncThunkWithNotification(
    'customers/data/get_units_drd',
    getUnits
)
export const get_brands_drd = createAsyncThunkWithNotification(
    'customers/data/get_brands_drd',
    getBrands
)
export const get_fabrics_drd = createAsyncThunkWithNotification(
    'customers/data/get_fabrics_drd',
    getFabrics
)
export const get_categories_drd = createAsyncThunkWithNotification(
    'customers/data/get_categories_drd',
    getCategories
)
export const get_delivery_partners_drd = createAsyncThunkWithNotification(
    'customers/data/get_delivery_partners_drd',
    getDeliveryPartners
)
export const get_suppliers_drd = createAsyncThunkWithNotification(
    'customers/data/get_suppliers_drd',
    getSuppliers
)
export const get_suppliers_by_id = createAsyncThunkWithNotification(
    'customers/data/get_suppliers_by_id',
    getSupplierById
)
const commonSlice = createSlice({
    name: 'common/data',
    initialState: {
        loading: false,
        customerDrd: [],
        productsDrd: [],
        colorsDrd:[],
        brandDrd: [],
        fabricDrd: [],
        categoriesDrd: [],
        unitsDrd: [],
        fieldsDrd: [],
        suppliersDrd: [],
        deliveryPartnerDrd: [],
        dressTypeDrd: [],
        clientSize: [],
        clientChilds: [],
        productsList: [],
        fabricList: [],
        tailorDrd: [],
        supplierDetail: null,
        clientDetail: null,
    },
    reducers: {
        updateProductList: (state, action) => {
            state.productsList = action.payload
        },
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        setFilterData: (state, action) => {
            state.filterData = action.payload
        },
        resetProductList: (state, action) => {
            state.productsList = []
            state.fabricList = []
        },
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload
        },
        setSupplierDetail: (state) => {
            state.supplierDetail = null
        },
        setClientDetail: (state) => {
            state.clientDetail = null
        },
        setClientSizes: (state, action) => {
            state.clientSize = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_customers_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, first_name, last_name }) => ({
                        label: `${first_name || ''} ${last_name || ''}`,
                        value: id,
                    })
                )
                state.customerDrd = customDrd
                state.loading = false
            })
            .addCase(get_taiilor_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, first_name, last_name }) => ({
                        label: `${first_name || ''} ${last_name || ''}`,
                        value: id,
                    })
                )
                state.tailorDrd = customDrd
                state.loading = false
            })
            .addCase(get_colors_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name, color }) => ({
                        label: name,
                        value: id,
                        color,
                    })
                )
                state.colorsDrd = customDrd
                state.loading = false
            })
            .addCase(get_client_by_id.fulfilled, (state, action) => {
                const clientDrd = action.payload.data?.data?.customer?.map(
                    ({ id, first_name, last_name }) => ({
                        label: `${first_name || ''} ${last_name || ''}`,
                        value: id,
                        sizes:action.payload.data?.data?.customer_sizes
                    })
                )
                const childDrd =
                    action.payload.data?.data?.customer_childs?.map(
                        ({ id, first_name, last_name, relation, sizes }) => ({
                            label: `${first_name || ''} ${
                                last_name || ''
                            } (${relation})`,
                            value: id,
                            sizes
                        })
                    )
                const customer_sizes = action.payload.data?.data?.customer_sizes
                state.clientDetail = {
                    drd: [...clientDrd, ...childDrd],
                    customer_sizes,
                    detail:action.payload.data?.data?.customer[0]
                }

                state.loading = false
            })
            .addCase(get_client_childs.fulfilled, (state, action) => {
                state.clientChilds = action.payload.data?.data
                state.loading = false
            })
            .addCase(get_client_sizes.fulfilled, (state, action) => {
                state.clientSize = action.payload.data?.data
                state.loading = false
            })
            .addCase(get_product_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.productsDrd = customDrd
                state.loading = false
            })
            .addCase(get_product_by_search.fulfilled, (state, action) => {
                state.productsList = action.payload.data?.data
                state.loading = false
            })
            .addCase(get_fabric_by_search.fulfilled, (state, action) => {
                state.fabricList = action.payload.data?.data
                state.loading = false
            })
            .addCase(get_units_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.unitsDrd = customDrd
                state.loading = false
            })
            .addCase(get_categories_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.categoriesDrd = customDrd
                state.loading = false
            })
            .addCase(get_brands_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.brandDrd = customDrd
                state.loading = false
            })
            .addCase(get_fabrics_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.fabricDrd = customDrd
                state.loading = false
            })
            .addCase(get_measurement_fields_drd.fulfilled, (state, action) => {
                state.fieldsDrd = action.payload.data?.data
                state.loading = false
            })
            .addCase(get_suppliers_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.suppliersDrd = customDrd
                state.loading = false
            })
            .addCase(get_suppliers_by_id.fulfilled, (state, action) => {
                state.supplierDetail = action.payload.data?.data[0]
                state.loading = false
            })
            .addCase(get_delivery_partners_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.deliveryPartnerDrd = customDrd
                state.loading = false
            })
            .addCase(get_dress_type_drd.fulfilled, (state, action) => {
                const customDrd = action.payload.data?.data?.map(
                    ({ id, name }) => ({
                        label: `${name || ''}`,
                        value: id,
                    })
                )
                state.dressTypeDrd = customDrd
                state.loading = false
            })
            .addMatcher(
                (action) => action.type.endsWith('/fulfilled'),
                (state) => {
                    state.loading = false
                }
            )
            .addMatcher(
                (action) => action.type.endsWith('/pending'),
                (state) => {
                    state.loading = true
                }
            )
            .addMatcher(
                (action) => action.type.endsWith('/rejected'),
                (state, action) => {
                    state.loading = false
                    toast.push(
                        <Notification
                            title={'Error'}
                            type="danger"
                            duration={2500}
                            closable
                        >
                            {action?.payload ||
                                'An error occurred. Please try again.'}
                        </Notification>,
                        {
                            placement: 'top-center',
                        }
                    )
                }
            )
    },
})

export const {
    updateProductList,
    setTableData,
    setFilterData,
    setCurrentRouteKey,
    resetProductList,
    setSupplierDetail,
    setClientDetail,
    setClientSizes
} = commonSlice.actions

export default commonSlice.reducer
